window.FormValidator = function(formClassName) {
    var self = this;
    const domMutationObserver = new YDomMutationObserver();

    var events = {
        "after-validation": [],
        "on-validation-error": [],
        "on-validation-success": [],
        "async-validation-done": []
    };

    var customValidations = {};

    var trigger = function(eventName, param1, param2, param3, param4) {
        events[eventName].forEach(function(handler){
            handler(param1, param2, param3, param4);
        });
    };

    self.afterValidation = function(handler) {
        events["after-validation"].push(handler);
    };

    self.onAsyncValidationDone = function(handler) {
        events["async-validation-done"].push(handler);
    };

    self.onError = function(handler) {
        events["on-validation-error"].push(handler);
    };

    self.onSuccess = function(handler) {
        events["on-validation-success"].push(handler);
    };

    self.validation = {};
    self.formLoaded = false;


    self.validateCustom = function(name, value, rule) {
        console.warn("No custom rule for, form:", formClassName, "Rule:", name, value, rule);
    };

    self.registerCustomValidation = function (rule, handler) {
        customValidations[rule] = handler;
    };

    self.triggerFieldDependencies = function(field, optionsField) {
        optionsField = optionsField || field;
        var validationTrigger = optionsField.attr("validate-trigger");
        var dependecies = parseValidationRules(validationTrigger);

        for (var i in dependecies) {
            var dependency = dependecies[i];
            var fields = optionsField.parents(dependency.params[0]).find(dependency.params[1]);

            fields.each(function () {
                $(this).trigger(dependency.name, ['auto-trigger']);
            });
        }
    };

    self.hasValidationErrors = () => {
        for (const fieldName in self.validation) {
            const fieldValidation = self.validation[fieldName];
            for (const error in fieldValidation.errors) {
                if (fieldValidation.errors[error]) {
                    return true;
                }
            }
        }
        return false;
    };

    self.validateSingleField = function (field, optionsField, showError, callback) {
        optionsField = optionsField || field;
        var validationRules = optionsField.attr("validate-rule");
        var rulesObject = parseValidationRules(validationRules);
        var numberOfCallbacks = rulesObject.length;
        var callbackCalled = false;
        var ruleCallbacks = [];
        var fieldInvalid = false;
        field.attr('aria-invalid', false);

        for (var i in rulesObject) {
            var rule = rulesObject[i];
            var name = field.attr("name");

            if (optionsField.attr("validate-index")) {
                name = name + optionsField.attr("validate-index");
            }


            if (!fieldInvalid) {
                if (callback) {
                    ruleCallbacks[i] = function (isValid) {
                        fieldInvalid = !isValid;

                        if (!isValid || --numberOfCallbacks == 0) {
                            field.attr('aria-invalid', !isValid);
                            if (!callbackCalled) {
                                callback(isValid);
                                callbackCalled = true;
                            }
                        }
                    }
                }

                var syncValidResult = runValidationRule(field, optionsField, rule, showError, ruleCallbacks[i]);

                if (typeof(syncValidResult) == 'boolean' && !syncValidResult) {
                    return false; // Invalid
                }
            }

        }

        return true;
    };

    self.listenForValidation = function() {

        if (!$("form." + formClassName).length) {
            console.warn("listen for validation called before class is attached to DOM:", `form.${formClassName}`);
            return;
        }
        var timeoutRef;

        domMutationObserver.init($("form." + formClassName)[0]);
        const handler = function (records) {
            if (records[0].target.innerHTML && records[0].target.innerHTML.length > 0) {

                clearTimeout(timeoutRef);

                timeoutRef = setTimeout(function() {
                    $("form." + formClassName + " [validate-rule]").each(function () {

                        var originalTarget = $(this);

                        const tagName = this.tagName.toLowerCase();
                        if (tagName.startsWith("hui-input-")) {
                            originalTarget = originalTarget.find("input, textarea");
                        }

                        var target;

                        if ($(this).attr("validate-target")) {
                            target = $(this).find($(this).attr("validate-target"));
                        }
                        else {
                            target = originalTarget;
                        }

                        var validateOn = $(this).attr("validate-on") || "change";
                        var triggerDelay = $(this).attr("validate-delay") || 1;

                        if (!target.attr("data-validate-binded")) {
                            target.on(validateOn, function (event, triggerType) {

                                var field;

                                if (originalTarget.attr("validate-trigger-target")) {
                                    field = target;
                                } else {
                                    field = $(this);
                                }


                                //TODO: find if it's corret to set it here
                                originalTarget.attr("data-dirty", true);

                                setTimeout(function() {
                                    if (originalTarget.attr("validate-rule")) {
                                        self.validateSingleField(field, originalTarget, true, function (valid) {
                                            trigger("after-validation");
                                        });
                                    }

                                    if (originalTarget.attr("validate-trigger") && triggerType != 'auto-trigger') {
                                        self.triggerFieldDependencies(field, originalTarget);
                                    }
                                }, parseInt(triggerDelay));
                            });

                            target.attr("data-validate-binded", true);
                        }

                    });
                }, 500);

            }
        };

        domMutationObserver.on(YDomMutationObserver.EVENTS.ON_CHANGE, handler);
        domMutationObserver.on(YDomMutationObserver.EVENTS.ON_SUBTREE_CHANGED, handler);
        domMutationObserver.on(YDomMutationObserver.EVENTS.ON_CHILD_LIST_CHANGED, handler);
        domMutationObserver.startListening();
    };


    self.validate = function(validateHiddenOrCallback, callback) {
        var formValid = true;
        var validateHidden = validateHiddenOrCallback;

        if (typeof(validateHiddenOrCallback) == 'function') {
            callback = validateHiddenOrCallback;
            validateHidden = false;
        }

        self.validation = {};

        var visibilitySelector = validateHidden? "": ":visible";
        var numberOfCallbacks = 0;

        var fieldsToValidate = $("form." + formClassName + visibilitySelector + " [validate-rule]");
        numberOfCallbacks = fieldsToValidate.length;

        //Empty form with Async Validation
        if (!numberOfCallbacks && callback) {
            callback((formValid && self.formLoaded));
            trigger("after-validation");
        }

        fieldsToValidate.each(function() {
            var target = $(this);

            if ($(this).attr("validate-target")) {
                target = $(this).find($(this).attr("validate-target"));
            }

            var fieldCallback;

            if (callback) {
                fieldCallback = function (valid) {

                    if (!valid) {
                        formValid = false;
                    }

                    if (--numberOfCallbacks == 0) {
                        callback((formValid && self.formLoaded));
                        trigger("after-validation");
                    }
                };
            }

            var validateSingleField = self.validateSingleField(target, $(this), true, fieldCallback);

            if (!callback && !validateSingleField) {
                formValid = false;
            }
        });

        if (!callback) {
            trigger("after-validation");
        }

        if (!self.formLoaded) {
            console.warn("Validation called before form loaded event is triggered", formClassName);
        }

        return formValid && self.formLoaded;
    };

    self.validateWithoutError = function () {
        var formValid = true;

        $("form." + formClassName + " [validate-rule]").each(function() {
            var target = $(this);

            if ($(this).attr("validate-target")) {
                target = $(this).find($(this).attr("validate-target"));
            }

            if (!self.validateSingleField(target, $(this), false)) {
                formValid = false;
            }
        });

        return formValid;
    };

    self.clearValidate = function (index) {
        for (var key in self.validation)
        {
            if (key.charAt(key.length - 1) == index)
            {
                delete self.validation[key];
            }
        }
    };

    self.hasFieldErrors = (fieldName) => {
        const errors = self.validation?.[fieldName]?.errors;
        if (!errors) {
            return false;
        }
        return Object.values(errors).some(error => error);
    };

    self.getFieldValue = function(field) {
        if (field.attr("type") == "checkbox") {
            return field.is(":checked");
        }

        if (field.attr("type") == "radio") {
            return field.filter(':checked').val();
        }

        return field.val();
    };

    //TODO: find if it's corret to set it here
    self.isDirty = function () {
        if($("form." + formClassName).find('*[data-dirty="true"]').length > 0) {
            return true;
        }

        return false;
    };

    //TODO: find if it's corret to set it here
    self.resetDirty = function () {
        $("form." + formClassName + " *[data-dirty='true']").attr("data-dirty", false);
    };

    var formatDateFromFieldValue = function (field) {
        var dateFormat = field.data("dateFormat");
        var value = self.getFieldValue(field);
        var date;

        if (!dateFormat) {
            date = value;
        }
        else {
            date = moment(value, dateFormat.toUpperCase(), moment.locale(), true).locale("en").format("YYYY-MM-DD");
        }

        return date;
    };

    var runValidationRule = function(field, optionsField, rule, showError, callback) {
        var name = field.attr("name");
        var value = self.getFieldValue(field);

        if (optionsField.attr("validate-index")) {
            name = name + optionsField.attr("validate-index");
        }

        if (showError) {
            self.validation[name] = {errors: {}, value: value};
        }

        if (!name) {
            console.warn("Validation called before field name is set for: Rule:", rule.name, "Field:", field);
        }

        var customRule = customValidations[rule.name];

        if (customRule) {
            var fieldCallback;

            if (callback) {
                fieldCallback = function (isValid) {
                    if (!isValid && showError) {
                        self.validation[name].errors[rule.name] = true;
                    }

                    callback(isValid);
                }
            }

            var isValid = true;

            try {
                isValid = customRule(field, optionsField, rule, showError, fieldCallback);
            } catch(err) {
                isValid = false;
                console.error(err);
            }

            if (typeof(isValid) == 'boolean') {
                if (!isValid && showError) {
                    self.validation[name].errors[rule.name] = true;
                }

                return (callback)? callback(isValid) : isValid;
            }
        }

        switch (rule.name) {
            case "required":
                if (!value || (typeof value === "string" && !(value.trim()))) {
                    if (showError) {
                        self.validation[name].errors[rule.name] = true;
                    }

                    return (callback)? callback(false) : false;
                }
                break;
            case "maxlength":
                if (value && value.length > parseInt(rule.params[0])) {
                    if (showError) {
                        self.validation[name].errors[rule.name] = true;
                        self.validation[name].maxlength = parseInt(rule.params[0]);
                    }

                    return (callback)? callback(false) : false;
                }
                break;

            case "minlength":
                if (!value || value.length < parseInt(rule.params[0])) {
                    if (showError) {
                        self.validation[name].errors[rule.name] = true;
                        self.validation[name].minlength = parseInt(rule.params[0]);
                    }

                    return (callback)? callback(false) : false;
                }
                break;

            case "phone":
                var regexp = Utils.getPhoneRegx();

                // exclude all characters expect numbers
                var cleanValue = value.replace(/[\(,\),\-,\ ,\+,\.]/g, '');

                if (value.trim() != ""){
                    if (cleanValue.length < 9) {
                        if (showError) {
                            self.validation[name].errors[rule.name] = true;
                        }

                        return (callback)? callback(false) : false;
                    }

                    if (!regexp.test(value)) {
                        if (showError) {
                            self.validation[name].errors[rule.name] = true;
                        }

                        return (callback)? callback(false) : false;
                    }
                }

                break;

            case "phoneNumber":

                /*g
                * When rule.params[0] equals to not-required
                * The Validator will works only in phone input has a value that not match
                * selected country phone intro code('+' + dialCode).
                * */

                if (value) {

                    var invalid = false;


                    var iti = window.intlTelInputGlobals.getInstance(field[0]);

                    if (rule.params[0] === 'not-required') {
                        var countryData = iti.getSelectedCountryData();
                        var dialCode = countryData.dialCode;
                        if (value !== ('+' + dialCode) && !window.intlTelInputUtils?.isValidNumber(value)) {
                            invalid = true;
                        }
                    } else {
                        if (!window.intlTelInputUtils?.isValidNumber(value)) {
                            invalid = true;
                        }
                    }

                    if (invalid) {
                        if (showError) {
                            self.validation[name].errors[rule.name] = true;
                        }
                        return (callback) ? callback(false) : false;
                    }
                }

                break;

            case 'noPlus':
                if (value?.includes('+')) {
                    if (showError) {
                        this.validation[name].errors[rule.name] = true;
                    }

                    return (callback) ? callback(false) : false;
                }

                break;

            case "email":
                var regexp = /^(([\w-]|(?:[\&]))+(?:[\+]*[\.]*[\']*[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,9}(?:\.[a-z]{2})?)$/i;

                if (value && !regexp.test(value.trim())) {
                    if (showError) {
                        self.validation[name].errors[rule.name] = true;
                    }

                    return (callback)? callback(false) : false;
                }
                break;

            case "emailExists":
                if (!callback) {
                    console.error("Email Exists rule should be run in Async validation only (with callback)");
                }

                if (value) {
                    var validIfExisting = rule.params[0];
                    var ruleName = rule.name;

                    UserAPI.emailExists(value)
                        .then(function (data) {

                            var validationData = {};
                            switch (data.status.status) {
                                case "USED":
                                    if (!validIfExisting && showError) {
                                        if (data.status.user.status === "NO_PASSWORD") {
                                            validationData['NO_PASSWORD'] = true;
                                        } else if (data.status.user.status === "DRAFT_NO_PASSWORD") {
                                            validationData['DRAFT_NO_PASSWORD'] = true;
                                        } else {
                                            validationData['EMAIL_USED'] = true;
                                        }
                                        self.validation[name].errors[ruleName] = true;
                                    }

                                    callback(validIfExisting);
                                    trigger("async-validation-done", ruleName, validIfExisting, validationData);
                                    break;

                                case "AVAILABLE":
                                    if (validIfExisting && showError) {
                                        self.validation[name].errors[ruleName] = true;
                                    }

                                    callback(!validIfExisting);
                                    trigger("async-validation-done", ruleName, validIfExisting);
                                    break;
                            }
                        });

                    // Async validations must return with undefined (not boolean)
                    return;
                }

                break;
            case "multi-selection":
                var multiSelection = value.split(',');
                if (multiSelection.length < parseInt(rule.params[0])){
                    if (showError) {
                        self.validation[name].errors[rule.name] = true;
                    }

                    return (callback)? callback(false) : false;
                }
                break;
            case "date-format":
                if (value) {
                    var date = formatDateFromFieldValue(field);

                    if (isNaN(Date.parse(date))) {
                        if (showError) {
                            self.validation[name].errors[rule.name] = true;
                        }

                        return (callback)? callback(false) : false;
                    }
                }
                break;
            case "min-date":
                if (value) {
                    var date = new moment(formatDateFromFieldValue(field));
                    var compareWith = new moment(rule.params[0]);

                    if (date.isBefore(compareWith)) {
                        if (showError) {
                            self.validation[name].errors[rule.name] = true;
                        }

                        return (callback)? callback(false) : false;
                    }
                }
                break;
            case "max-date":
                if (value) {
                    var date = new moment(formatDateFromFieldValue(field));
                    var compareWith = new moment(rule.params[0]);

                    if (date.isAfter(compareWith)) {
                        if (showError) {
                            self.validation[name].errors[rule.name] = true;
                        }

                        return (callback)? callback(false) : false;
                    }
                }
                break;
            case "pastDate":
                if (value) {
                    var date = new moment(formatDateFromFieldValue(field));

                    if (date.isAfter(Date.now())) {
                        if (showError) {
                            self.validation[name].errors[rule.name] = true;
                        }

                        return (callback)? callback(false) : false;
                    }
                }
                break;
            case "birthDateRange":
                if (value) {
                    var date = new moment(formatDateFromFieldValue(field));
                    var now = new moment(new Date());

                    var age = now.diff(date, 'years', true);

                    if (age < 10 || age > 90) {
                        if (showError) {
                            self.validation[name].errors[rule.name] = true;
                        }
                        return (callback) ? callback(false) : false;
                    }
                }
                break;
            case "futureDate":
                if (value) {
                    var date = new moment(formatDateFromFieldValue(field));

                    if (date.isBefore(Date.now())) {
                        if (showError) {
                            self.validation[name].errors[rule.name] = true;
                        }

                        return (callback)? callback(false) : false;
                    }
                }
                break;
            case "integer":

                if(value){

                    var _fieldValue = parseFloat(value);

                    if(!isNaN(_fieldValue) && ((_fieldValue | 0) !== _fieldValue)){
                        if (showError) {
                            self.validation[name].errors[rule.name] = true;
                        }

                        return (callback)? callback(false) : false;
                    }
                }

                break;
            case "min-value":
                if (value && (isNaN(parseFloat(value)) || parseFloat(value) < parseFloat(rule.params[0]))) {
                    if (showError) {
                        self.validation[name].errors[rule.name] = true;
                        self.validation[name].minValue = parseFloat(rule.params[0]);
                    }

                    return (callback)? callback(false) : false;
                }
                break;
            case "max-value":
                if (value && (isNaN(parseFloat(value)) || parseFloat(value) > parseFloat(rule.params[0]))) {
                    if (showError) {
                        self.validation[name].errors[rule.name] = true;
                        self.validation[name].maxValue = parseFloat(rule.params[0]);
                    }

                    return (callback)? callback(false) : false;
                }
                break;
            case "is-digits":
                if (value && isNaN(value)) {
                    if (showError) {
                        self.validation[name].errors[rule.name] = true;
                    }

                    return (callback)? callback(false) : false;
                }
                break;
            case "exact-length":
                if (value && value.length != parseInt(rule.params[0])) {
                    if (showError) {
                        self.validation[name].errors[rule.name] = true;
                    }

                    return (callback)? callback(false) : false;
                }
                break;
            case "no-validation" :
                break;
            case "pattern":
                var regExp = optionsField.attr("validate-pattern");

                var pattern = new RegExp(regExp);

                if (value && !pattern.test(value.trim())) {
                    if (showError) {
                        self.validation[name].errors[rule.name] = true;
                    }

                    return (callback)? callback(false) : false;
                }
                break;
            case "uk-postcode-pattern":
                var regex = new RegExp(/^([A-PR-UWYZ0-9][A-HK-Y0-9][ACDEFGHJKMNPRTUVXY0-9]?[ABEHMNPRVWXY0-9]? {1,2}[0-9][ABD-HJLN-UW-Z]{2}|GIR 0AA)$/);

                if(value && !regex.test(value)) {
                    if (showError) {
                        self.validation[name].errors[rule.name] = true;
                    }
                    return (callback)? callback(false) : false;
                }
                break;
            case "alphanumeric":
                var regex = new RegExp(/^[a-z0-9]+$/i);
                if(value && !regex.test(value)) {
                    if (showError) {
                        self.validation[name].errors[rule.name] = true;
                    }
                    return (callback)? callback(false) : false;
                }
                break;
            case "url":
                var regexp = /^http[s]?:\/\/(?:(?:[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?\.)+[A-Z]{2,63}\.?|localhost|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})(?::\d+)?(?:\/?|[\/?]\S+)$/i;
                //var regexp = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/;
                if (value && !regexp.test(value)) {
                    if (showError) {
                        self.validation[name].errors[rule.name] = true;
                    }

                    return (callback)? callback(false) : false;
                }
                break;
            case "password":

                if(value && !Utils.validatePassword(value).pass){

                    if (showError) {

                        self.validation[name].errors[rule.name] = true;
                    }

                    return (callback)? callback(false) : false;
                }

                break;

            case "ssn":

                if (value) {
                    var ssn = value.replace(/ /g, "").replace(/-/g, "");
                    if (ssn.length < 9 || isNaN(ssn)) {

                        if (showError) {

                            self.validation[name].errors[rule.name] = true;
                        }

                        return (callback) ? callback(false) : false;
                    }
                }

                break;

            case "cpr":

                if (value) {
                    var cpr = value.replace(/ /g, "").replace(/-/g, "");
                    if (cpr.length < 10 || isNaN(cpr)) {

                        if (showError) {

                            self.validation[name].errors[rule.name] = true;
                        }

                        return (callback) ? callback(false) : false;
                    }
                }

                break;

            case "no-special-characters":
                var regex = new RegExp(/[&\/\\”?<>#{}%@~.'"]/);
                if (value && regex.test(value)) {
                    if (showError) {
                        self.validation[name].errors[rule.name] = true;
                        return false;
                    }
                }
                break;

            case "no-spaces":
                var regex = /\s/;
                if (value && regex.test(value.trim())) {
                    if (showError) {
                        self.validation[name].errors[rule.name] = true;
                    }

                    return (callback)? callback(false) : false;
                }
                break;

            case "color":
                var s = new Option().style;
                s.color = value;
                if (s.color === '') {
                    if (showError) {
                        self.validation[name].errors[rule.name] = true;
                    }
                    return (callback) ? callback(false) : false;
                }
                break;

            case "html-required":
                const container = $('<div>'+value+'</div>');
                const hasValidImage = container.find('img').filter(function() {
                    return !!$(this).attr('src')?.trim();
                }).length > 0;
                if (!container.text() && !hasValidImage) {
                    if (showError) {
                        self.validation[name].errors[rule.name] = true;
                    }

                    return (callback) ? callback(false) : false;
                }
                break;

            case "html-maxlength":
                var maxLength = parseInt(rule.params[0]);
                if ($('<div>'+value+'</div>').text().length > maxLength) {
                    if (showError) {
                        self.validation[name].errors[rule.name] = true;
                    }

                    return (callback) ? callback(false) : false;
                }
                break;

            case "html-minlength":
                var minLength = parseInt(rule.params[0]);
                if ($('<div>'+value+'</div>').text().length < minLength) {
                    if (showError) {
                        self.validation[name].errors[rule.name] = true;
                    }

                    return (callback) ? callback(false) : false;
                }
                break;

            case 'validFraction': {
                const validNumberOfFractionalDecimals = (value, maxDecimals) => {
                    const fractionalPart = value?.toString().split('.')[1];
                    return !(
                        fractionalPart?.length > maxDecimals
                    );
                };

                const parsedValue = parseFloat(value);
                const maxDecimals = rule.params?.length > 0 ?
                    parseFloat(rule.params[0]) :
                    2;

                if (
                    value &&
                    (
                        isNaN(parsedValue) ||
                        !validNumberOfFractionalDecimals(parsedValue, maxDecimals)
                    )
                ) {
                    if (showError) {
                        self.validation[name].errors[rule.name] = true;
                        self.validation[name].validFraction = maxDecimals;
                    }

                    return callback?.(false) ?? false;
                }
                break;
            }

            default:
                var fieldCallback;
                if (callback) {
                    fieldCallback = function (isValid) {
                        if (!isValid && showError) {
                            self.validation[name].errors[rule.name] = true;
                        }

                        callback(isValid);
                    }
                }

                var isValid = self.validateCustom(field, optionsField, rule, showError, fieldCallback);
                if (typeof(isValid) == 'boolean') {
                    if (!isValid && showError) {
                        self.validation[name].errors[rule.name] = true;
                    }

                    return (callback)? callback(isValid) : isValid;
                }

                return;
        }
        return (callback)? callback(true) : true;
    };

    var parseValidationRules = function(validationString) {
        var rules = [];

        if (validationString) {
            validationString.split("|").forEach(function(ruleString) {
                var ruleParts = ruleString.trim().split(":");
                var ruleName = ruleParts.shift();
                rules.push({
                    'name': ruleName,
                    'params': ruleParts
                });
            });
        }

        return rules;
    }

};
